import { useLenis } from "../hooks/useLenis";
import { Nav } from "../components/portfolio/Nav";
import { Hero } from "../components/portfolio/Hero";
import { StatsBar } from "../components/portfolio/StatsBar";
import { About } from "../components/portfolio/About";
import { Experience } from "../components/portfolio/Experience";
import { Leadership } from "../components/portfolio/Leadership";
import { Skills } from "../components/portfolio/Skills";
import { Education } from "../components/portfolio/Education";
import { CaseStudy } from "../components/portfolio/CaseStudy";
import { Contact } from "../components/portfolio/Contact";
import { Footer } from "../components/portfolio/Footer";

export default function Portfolio() {
  useLenis();

  return (
    <div data-testid="portfolio-page" className="bg-paper">
      <Nav />
      <main>
        <Hero />
        <StatsBar />
        <About />
        <Experience />
        <Leadership />
        <Skills />
        <Education />
        <CaseStudy />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
